/**
 * Cart add-on bundle remove:
 * removing one line removes all lines that share the same _bundle_id.
 * Uses one `change.js` POST per line (parallel): `update.js` with multiple line keys is unreliable for distinct property rows.
 */
;(function () {
  'use strict'

  if (window.__addonCartRemoveLoaded) return
  window.__addonCartRemoveLoaded = true

  /**
   * @returns {string}
   */
  function cartJsUrl() {
    if (window.theme && theme.routes && theme.routes.cart) {
      return theme.routes.cart
    }
    return '/cart.js'
  }

  /**
   * @returns {string}
   */
  function cartChangeJsUrl() {
    if (window.theme && theme.routes && theme.routes.cartChange) {
      return theme.routes.cartChange
    }
    return '/cart/change.js'
  }

  function fetchCart() {
    return fetch(cartJsUrl(), {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart fetch failed')
      return res.json()
    })
  }

  /**
   * @param {string} key
   * @returns {string}
   */
  function findBundleIdByLineKey(key) {
    var row = document.querySelector('.cart__item[data-key="' + String(key) + '"]')
    return row ? row.getAttribute('data-addon-bundle-id') || '' : ''
  }

  /**
   * Sets quantity to 0 for each line key via `change.js`, then returns fresh cart JSON.
   * @param {string[]} keys
   * @returns {Promise<object>}
   */
  function removeKeys(keys) {
    if (!keys.length) {
      return fetchCart()
    }

    var changeUrl = cartChangeJsUrl()
    var bust = changeUrl.indexOf('?') === -1 ? '?t=' : '&t='

    return Promise.allSettled(
      keys.map(function (key) {
        return fetch(changeUrl + bust + Date.now(), {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            Accept: 'application/json',
          },
          body: JSON.stringify({
            id: key,
            quantity: 0,
          }),
        }).then(function (res) {
          if (!res.ok) throw new Error('Cart change failed')
          return res.json()
        })
      })
    ).then(function () {
      return fetchCart()
    })
  }

  /**
   * @param {string} bundleId
   * @returns {Promise<object>}
   */
  function removeBundle(bundleId) {
    return fetchCart().then(function (cart) {
      var keys = (cart.items || [])
        .filter(function (item) {
          return item && item.properties && item.properties._bundle_id === bundleId
        })
        .map(function (item) {
          return item.key
        })

      if (!keys.length) {
        throw new Error('No bundle rows to remove')
      }

      return removeKeys(keys)
    })
  }

  /**
   * @param {object} cart
   */
  function refreshCartUI(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: { cart: cart },
      })
    )
    document.dispatchEvent(new CustomEvent('cart:build'))
  }

  document.addEventListener(
    'click',
    function (evt) {
      var link =
        evt.target.closest &&
        evt.target.closest('.cart__remove a.text-link[href*="quantity=0"]')
      if (!link) return

      var row = link.closest('.cart__item')
      if (!row) return

      var bundleId = row.getAttribute('data-addon-bundle-id')
      if (!bundleId) return

      evt.preventDefault()

      removeBundle(bundleId)
        .then(function (cart) {
          refreshCartUI(cart)
        })
        .catch(function () {
          window.location.href = link.href
        })
    },
    true
  )

  /**
   * Handles quantity-to-zero actions (minus button/input) for bundle lines.
   * @param {CustomEvent} evt
   */
  function onCartQuantity(evt) {
    var detail = evt.detail || []
    var key = detail[0]
    var qty = parseInt(detail[1], 10)

    if (!key || isNaN(qty) || qty > 0) return

    var bundleId = findBundleIdByLineKey(key)
    if (!bundleId) return

    removeBundle(bundleId)
      .then(function (cart) {
        refreshCartUI(cart)
      })
      .catch(function () {})
  }

  document.addEventListener('cart:quantity.cart-page', onCartQuantity)
  document.addEventListener('cart:quantity.cart-cart-drawer', onCartQuantity)
  document.addEventListener('cart:quantity.cart-header', onCartQuantity)
})()
